module.exports = __webpack_public_path__ + "static/media/item_23_9_comp.91596b46.png";